import React from "react";
import { Game } from "./components/Game";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Game rounds="10" />
    </div>
  );
}

export default App;
